module.exports = function( a ) {
  return ( a === 0 || Math.abs( a ) < 0.000001 );
};
